import Crud from '../views/Fine/Crud'
import Entity from '../views/Fine/Add'

let routes = {
    path: '/fines',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/fines/add',
            name: 'NewFine',
            component: Entity,
            meta: {
                pageTitle: 'Fine',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/fines'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fines/edit/:id?',
            name: 'EditFine',
            component: Entity,
            meta: {
                pageTitle: 'Fine',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/fines'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/fines',
            name: 'list-fines',
            component: Crud,
            meta: {
                pageTitle: 'Fines',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
